module.exports = __webpack_public_path__ + "static/media/emojis.c17c6d4c.svg";